<template>
    <div class="large-container">
        <form class="login-form" @submit.prevent="RecoverUserCall($event)" >
            <h2 class="left">1.- Favor de utilizar el número con el que se dió de alta anteriormente.</h2>
            <input type="number" class="form-control left"  name="phone"  id="phone"  placeholder="Teléfono fijo">
            <input type="number" class="form-control left"  name="mobile" id="mobile" placeholder="Teléfono movil">
            <input type="email"  class="form-control left"  name="email"  id="email"  placeholder="Email" required>
            <div class="large-container">
                <input class="ui green button wide" type="submit" value="Hacer llamada de verificación" >
            </div>
            <br><br>
        </form>
        <form class="login-form" @submit.prevent="RecoverUserCode($event)" >
            <h2 class="left">2.- Introduzca el código que se le dió en la llamada.</h2>
            <input type="number" class="form-control left" hidden name="phone"  id="phone"  placeholder="Teléfono fijo" data-phone>
            <input type="number" class="form-control left" hidden name="mobile" id="mobile" placeholder="Teléfono movil" data-mobile>
            <input type="email"  class="form-control left" hidden name="email"  id="email"  placeholder="Email" data-email>
            <input type="text"   class="form-control left" name="code"   id="code"   placeholder="Código de Verificación de 4 Dígitos">
            <div class="large-container">
                <input class="ui blue button wide" type="submit" name="checkCode" value="Verificar Código" disabled>
            </div>
            <br><br>
        </form>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    methods:{
        ...mapActions(['RecoverUserCall','RecoverUserCode'])
    }
}
</script>